var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUzbekistan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.566625 8.34782C0.199031 9.49944 -4.68667e-05 10.7263 8.276e-09 11.9998C-4.68667e-05 13.2734 0.199078 14.5004 0.566672 15.652L12 16.1738L23.4333 15.6521C23.8009 14.5004 24 13.2734 24 11.9999C24 10.7263 23.8009 9.49944 23.4333 8.34777L12 7.82605L0.566625 8.34782Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4332 8.34789L11.9999 7.82617L0.5665 8.34789C0.457563 8.68933 0.363766 9.03747 0.285156 9.39138H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.285156 14.6086C0.363672 14.9625 0.457469 15.3106 0.566406 15.6521L0.567531 15.6521L11.9997 16.1738L23.433 15.6521C23.542 15.3107 23.6357 14.9625 23.7143 14.6086H0.285156Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 23.9999C17.3536 23.9999 21.8878 20.4935 23.433 15.6521H0.566406C2.11164 20.4935 6.64595 23.9999 11.9997 23.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 4.69973e-10C6.64595 4.68755e-05 2.11173 3.50644 0.566406 8.34783L23.433 8.34787C21.8879 3.50639 17.3536 -4.68745e-05 11.9997 4.69973e-10Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48376 4.95655C5.48376 3.83262 6.27365 2.89372 7.32848 2.66337C7.16638 2.62794 6.99815 2.60876 6.82537 2.60876C5.52871 2.60876 4.47754 3.65989 4.47754 4.95659C4.47754 6.2533 5.52862 7.30442 6.82537 7.30442C6.99815 7.30442 7.16634 7.2852 7.32848 7.24981C6.2737 7.01937 5.48376 6.08047 5.48376 4.95655Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71628 6.02368L8.87519 6.51282H9.3895L8.97344 6.81517L9.13234 7.30431L8.71628 7.00201L8.30012 7.30431L8.45908 6.81517L8.04297 6.51282H8.55728L8.71628 6.02368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3578 6.02368L10.5167 6.51282H11.0311L10.6149 6.81517L10.7739 7.30431L10.3578 7.00201L9.94168 7.30431L10.1006 6.81517L9.68457 6.51282H10.1988L10.3578 6.02368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 6.02368L12.1584 6.51282H12.6727L12.2566 6.81517L12.4155 7.30431L11.9995 7.00201L11.5833 7.30431L11.7423 6.81517L11.3262 6.51282H11.8405L11.9995 6.02368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6411 6.02368L13.8 6.51282H14.3143L13.8982 6.81517L14.0572 7.30431L13.6411 7.00201L13.2249 7.30431L13.3839 6.81517L12.9678 6.51282H13.4821L13.6411 6.02368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 6.02368L15.4415 6.51282H15.9559L15.5398 6.81517L15.6987 7.30431L15.2826 7.00201L14.8665 7.30431L15.0254 6.81517L14.6094 6.51282H15.1236L15.2826 6.02368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3578 4.31616L10.5167 4.80526H11.0311L10.6149 5.10765L10.7739 5.59674L10.3578 5.29444L9.94168 5.59674L10.1006 5.10765L9.68457 4.80526H10.1988L10.3578 4.31616Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 4.31616L12.1584 4.80526H12.6727L12.2566 5.10765L12.4155 5.59674L11.9995 5.29444L11.5833 5.59674L11.7423 5.10765L11.3262 4.80526H11.8405L11.9995 4.31616Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6411 4.31616L13.8 4.80526H14.3143L13.8982 5.10765L14.0572 5.59674L13.6411 5.29444L13.2249 5.59674L13.3839 5.10765L12.9678 4.80526H13.4821L13.6411 4.31616Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 4.31616L15.4415 4.80526H15.9559L15.5398 5.10765L15.6987 5.59674L15.2826 5.29444L14.8665 5.59674L15.0254 5.10765L14.6094 4.80526H15.1236L15.2826 4.31616Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 2.60864L12.1584 3.09783H12.6727L12.2566 3.40013L12.4155 3.88931L11.9995 3.58702L11.5833 3.88931L11.7423 3.40013L11.3262 3.09783H11.8405L11.9995 2.60864Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6411 2.60864L13.8 3.09783H14.3143L13.8982 3.40013L14.0572 3.88931L13.6411 3.58702L13.2249 3.88931L13.3839 3.40013L12.9678 3.09783H13.4821L13.6411 2.60864Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 2.60864L15.4415 3.09783H15.9559L15.5398 3.40013L15.6987 3.88931L15.2826 3.58702L14.8665 3.88931L15.0254 3.40013L14.6094 3.09783H15.1236L15.2826 2.60864Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/8dcbc804.svg";
export { SvgUzbekistan as ReactComponent };